import script from "./DownloadMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadMenu.vue?vue&type=script&setup=true&lang=js"

import "./DownloadMenu.vue?vue&type=style&index=0&id=049d3fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049d3fbc"]])

export default __exports__